import React from 'react';
import classNames from 'classnames';
import { Link } from "react-router-dom";

import { ProgressBar } from "../ProgressBar";
import { TopicContent } from "../../content/topics";

import './styles.scss';

export const TopicCard: React.FC<TopicContent> = ({
  isUnlocked,
  redirectPath,
  imagePath,
  imageAlt,
  lessons,
}) => {

  return (
    <div className={classNames("TopicCard", {
      "isLocked": !isUnlocked,
    })}>
      <Link
        to={redirectPath}
        onClick={e => !isUnlocked && e.preventDefault()}
        state={{ topic: { lessons, imagePath, imageAlt } }}
      >
        <img src={imagePath} alt={imageAlt} className={classNames("Image")}/>
      </Link>
      <ProgressBar withLock={true} isUnlocked={isUnlocked} />
    </div>
  );
};
